import { Menu, Tag, Typography } from 'antd';
import styled from 'styled-components';

export const StyledMenu = styled(Menu).attrs({
  multiple: true,
})`
  .ant-menu-title-content {
    display: block;
    width: 100%;
  }
  .ant-menu-item-selected {
    background-color: ${({ theme }) => theme.colorSuccessBg};
  }
  .anticon-check {
    color: ${({ theme }) => theme.colorPrimary};
    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const StyledMenuItem = styled.div.attrs({
  style: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 0,
    margin: 0,
    width: '100%',
    height: '48px',
  },
})``;

export const StyledMenuTitle = styled(Typography.Title).attrs({
  style: {
    marginBottom: 0,
  },
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PrimaryTag = styled(Tag)`
  background-color: ${({ theme }) => theme.colorSuccessBg};
  border-color: ${({ theme }) => theme.colorSuccessBg};
  color: ${({ theme }) => theme.colorPrimary};
`;
